import AecModelDataViewport from '../ViewportTypes/AecModelDataViewport.js';
import ViewportProviderInterface from './ViewportProviderInterface.js';

export default class AecModelDataViewportProvider extends ViewportProviderInterface {
    /**
     * Fetch viewports for a given bubble.
     *
     * @param {Autodesk.Viewing.BubbleNode} bubbleNode - bubbleNode.
     *
     * @returns {Promise<[Viewport]>} Promise with array of viewports.
     */
    async fetchViewports(bubbleNode) {
        const rootNode = bubbleNode.getRootNode();
        const aecModelData = rootNode.getAecModelData();

        const viewportsRaw = bubbleNode.is2D() ?
            Autodesk.AEC.AecModelData.findViewportsOnSheet(bubbleNode) :
            aecModelData?.viewports;

        if (!viewportsRaw) {
            return [];
        }

        const viewports = viewportsRaw.map(viewportRaw => {
            // Since viewport name is not extracted to AecModelData - we use the sheet's name for now.
            const sheetNode = rootNode.search({ guid: viewportRaw.sheetGuid })[0];

            if (!sheetNode) {
                console.warn("Shouldn't happen - couldn't find corresponding sheet.");
                return;
            }

            const name = sheetNode.name();
            const urn = rootNode.urn();

            // Since viewport name is not included in AecModelData - we use the sheet's name for now.
            const sheetName = name;

            return new AecModelDataViewport(viewportRaw, name, urn, sheetName, { aecModelData, sheetNode });
        });

        return viewports;
    }

    /**
     * @returns {string} Name of viewport provider
     */
    static getProviderName() {
        return 'AecModelDataViewportProvider';
    }

    async deleteViewport() {
        console.warn('Viewport deletion not allowed for AecModelData');
        return false;
    }
}
